import { tw } from '@ds/utils/tailwind'

export const SQUARE_CLASS = tw`aspect-square`

export const BIG_ITEM_SIZE_CLASS = tw`${SQUARE_CLASS} !h-[var(--carousel-big-item-size)] w-[var(--carousel-big-item-size)] !max-h-[var(--carousel-big-item-max-size)] !max-w-[var(--carousel-big-item-max-size)]`
export const SMALL_ITEM_SIZE_CLASS = tw`${SQUARE_CLASS} !h-[var(--carousel-small-item-size)] w-[var(--carousel-small-item-size)] !max-h-[var(--carousel-small-item-max-size)] !max-w-[var(--carousel-small-item-max-size)]`

export const BIG_GRID_ITEM_CLASS = tw`[grid-row:span_2] [grid-column:span_2]`
export const SMALL_GRID_ITEM_CLASS = tw`[grid-row:span_1] [grid-column:span_1]`
